import { useState, useEffect, useCallback } from "react";
import { ProductService } from "../../../services/ProductService.js";

const productService = new ProductService();

const useEmpresas = (baseUrl) => {
  const [empresa, setEmpresa] = useState(null);
  const [listaEmpresas, setListaEmpresas] = useState([]);

  const obtenerEmpresas = useCallback(async () => {
    try {
      const data = await productService.getAllEmpresas(baseUrl);
      setListaEmpresas(data.empresas);
      if (data.empresas && data.empresas.length > 0) {
        setEmpresa(data.empresas[0].id);
      }
    } catch (error) {
      console.error("Error al obtener las empresas:", error);
    }
  }, [baseUrl]);

  useEffect(() => {
    obtenerEmpresas();
  }, [obtenerEmpresas]);

  const nombreEmpresa = listaEmpresas.find((item) => item.id === empresa)?.nombre;

  return { empresa, setEmpresa, listaEmpresas, nombreEmpresa };
};

export default useEmpresas;
